import styled from "styled-components"
import { device } from "breakpoints"

export const InternalHeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid ${props => props.theme[props.color][2]};
  padding-bottom: 50px;
  border-bottom: ${props => props.noLine && "none"};

  @media ${device.desktop} {
    padding-bottom: 75px;
  }

  h1 {
    font-size: 32px;
    /* margin-bottom: 15px; */
    display: inline-block;
    align-self: flex-start;
    @media ${device.tablet} {
      font-size: 39px;
    }
    @media ${device.desktop} {
      width: 73%;
      font-size: 50px;
    }

    span {
      background: ${props => props.theme[props.color][0]};
      padding: 5px 0px;
      line-height: 150%;

      @media ${device.desktop} {
        padding: 2px 0px;

        line-height: 110%;
      }
    }
  }

  p {
    font-size: 20px;
    margin-top: 15px;
    @media ${device.desktop} {
      margin-top: 35px;
      font-size: 24px;
      width: 67%;
    }
  }
`
